import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ImageWithFallback } from '../ui/ImageWithFallback';

interface StorefrontCategoriesProps {
  categories: string[];
  getCategoryImage: (cat: string) => string;
}

export const StorefrontCategories = ({ categories, getCategoryImage }: StorefrontCategoriesProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {categories.map((cat, index) => (
        <button
          key={cat + index}
          onClick={() => navigate(`/categories?category=${encodeURIComponent(cat)}`)}
          className="group relative h-48 md:h-72 rounded-[2.5rem] overflow-hidden bg-white shadow-lg border border-slate-100 transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
        >
          <div className="absolute inset-0 transition-transform duration-700 group-hover:scale-110">
            <ImageWithFallback src={getCategoryImage(cat)} alt={cat} wrapperClassName="absolute inset-0 w-full h-full" className="w-full h-full object-cover opacity-80" referrerPolicy="no-referrer" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/95 via-slate-950/50 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-300" />
          <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 text-left transition-transform duration-500 group-hover:-translate-y-2">
            <p className="hidden md:block text-[10px] font-bold text-indigo-400 uppercase tracking-[0.3em] mb-2 font-display">Elite Collection</p>
            <h3 className="text-lg md:text-2xl font-black text-white uppercase tracking-tight leading-tight font-display drop-shadow-md break-words">
              {cat}
            </h3>
          </div>
          <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity translate-x-4 group-hover:translate-x-0">
             <div className="w-2 h-2 bg-white rounded-full" />
          </div>
        </button>
      ))}
      
      {/* Special Dr to Dr Hub Card */}
      <button
          onClick={() => navigate(`/categories?category=${encodeURIComponent('Dr to Dr Hub')}`)}
          className="group relative h-40 md:h-64 rounded-[2rem] md:rounded-[2.5rem] overflow-hidden bg-indigo-600 shadow-sm border border-indigo-500 transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
        >
          <div className="absolute inset-0 transition-transform duration-700 group-hover:scale-110 opacity-40">
            <ImageWithFallback src={getCategoryImage('Dr to Dr Hub')} alt="Dr to Dr Hub" wrapperClassName="absolute inset-0 w-full h-full" className="w-full h-full object-cover" referrerPolicy="no-referrer" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/90 via-indigo-900/40 to-transparent" />
          <div className="absolute bottom-4 left-4 md:bottom-8 md:left-8 text-left">
            <p className="hidden md:block text-[9px] font-black text-white/50 uppercase tracking-[0.4em] mb-2 font-display">Sellers Hub</p>
            <h4 className="text-xs sm:text-sm md:text-lg font-black text-white uppercase tracking-tight leading-tight font-display">
              Dr to Dr Hub
            </h4>
          </div>
          <div className="absolute top-4 right-4">
             <div className="px-3 py-1 bg-white/20 backdrop-blur-md rounded-full text-[8px] font-black text-white uppercase tracking-widest border border-white/20">Marketplace</div>
          </div>
        </button>
    </div>
  );
};
